import { useEffect, useState } from "react";
import MaterialTable from "material-table";
import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Base from "../../../Base/views/Base";
import Popup from "../../../Base/views/Popup";
import AddExpensePopUp from "../../helper/HelperComponents/AddExpensePopUp";
import { DeleteEmployeeExpenseAction, GetEmployeeExpenseAction } from "../../../../../store/Finance/Expense/Action";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDialog from "../../../Base/views/ConfirmationDialog";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { ConvertDate, getImageSignedUrl } from "../../../Base/helper/baseFunctions";
import { toast } from "react-toastify";
import CommentIcon from '@mui/icons-material/Comment';

const MyExpense = () => {
  const dispatch = useDispatch();
  const {
    employee_expenses,
    employeeExpenseLoading,
  } = useSelector((state) => state?.FinanceReducer?.ExpenseReducer);
  const [openPopup, setOpenPopup] = useState(false);
  const [editedRecord, setEditedRecord] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentData, setCurrentData] = useState(null);
 

  const handleAddExpenses = () => {
    setOpenPopup(true);
  };
  const handleEdit = (rowData) => {
    setEditedRecord(rowData);
    setOpenPopup(true);
  };
  const closeMode = (resetForm) => {
    setEditedRecord(null);
    setOpenPopup(false);
  };
  const handleConfirmDelete = (rowData) => {
    setOpenDialog(true);
    setCurrentData(rowData);
  };
  const handleDelete = () => {
    setOpenDialog(false);
    dispatch(DeleteEmployeeExpenseAction({ employee_expenses_pk: currentData?.employee_expenses_pk }))
    setCurrentData(null);
  };
  useEffect(() => {
    dispatch(GetEmployeeExpenseAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleView = async (event, rowData) => {
    event.stopPropagation();
    let filename = rowData?.proof;
    try {
      const url = await getImageSignedUrl(filename);
      if (filename?.endsWith(".doc") || filename?.endsWith(".docx")) {
        window.open(
          `https://docs.google.com/viewer?url=${encodeURIComponent(
            url
          )}&embedded=true`,
          "_blank"
        );
      } else {
        window.open(url, "_blank");
      }
      return url;
    } catch (err) {
      toast.error(err);
    }
  };
  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto" }}>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
          pt={1.5}
          pb={1}
          container
        >
          <Grid pr={1} item xs={12} sm={2.5}>
          </Grid>
          <Button
            sx={{
              fontWeight: 700,
              borderRadius: "8px",
              fontSize: "13px",
              height: "38px",
              padding: "4px 10px",
              boxShadow: "none",
              lineHeight: 1.71429,
              marginRight: "10px",
            }}
            size="small"
            variant="contained"
            className="mpl-primary-btn"
            onClick={() => handleAddExpenses()}
          >
            + Add Expense
          </Button>
        </Grid>
        <Box>
          <MaterialTable
            isLoading={employeeExpenseLoading}
            columns={[
              {
                title: "Category",
                field: "expense_name",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                  width: "15%",
                  cursor: "pointer"
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "7px 0px 7px 13px",
                  width: "15%"
                },
              },
              {
                field: "sub_expense_type_name",
                title: "Subcategory",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                  width: "20%",
                  cursor: "pointer"
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "7px 0px 7px 10px",
                  width: "20%"
                },
              },
              {
                field: "entry_date",
                title: "Date",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                  width: "10%",
                  cursor: "pointer"
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "7px 0px 7px 10px",
                  width: "10%",
                },
                render: (rowData) => ConvertDate(rowData?.entry_date)
              },
              {
                field: "employee_amount",
                title: "Claimed Amount",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                  width: "10%",
                  cursor: "pointer"
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "7px 0px 7px 13px",
                  width: "10%",
                },
              },
              {
                field: "proof",
                title: "Proof",
                sorting: false,
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "center",
                  width: "5%",
                  cursor: "default"
                },
                cellStyle: {
                  textAlign: "center",
                  padding: "7px 0px 7px 10px",
                  width: "5%"
                },
                render: (rowData) => (
                  <div onClick={(e) => e.stopPropagation()}>
                    {rowData.proof ? (
                      <IconButton
                        onClick={(event) => handleView(event, rowData)}
                      >
                        <VisibilityIcon />
                      </IconButton>
                    ) : (
                      <IconButton disabled>
                        <VisibilityOffIcon />
                      </IconButton>
                    )}
                  </div>
                ),
              },
              {
                field: "employee_status",
                title: "Status",
                headerStyle: {
                  textAlign: "center",
                  width: "10%",
                  cursor: "pointer"
                },
                cellStyle: {
                  textAlign: "center",
                  width: "10%"
                },
                render: (rowData) => {
                  const { bg, text } = getStatusColor(rowData.employee_status);
                  return (
                    <Chip
                      label={rowData.employee_status}
                      style={{
                        backgroundColor: bg,
                        color: text,
                        fontWeight: 500,
                      }}
                      size="small"
                    />
                  );
                },
              },
              {
                field: "finance_approver_amount",
                title: "Approved Amount",
                headerStyle: {
                  padding: "5px 0px 5px 10px",
                  textAlign: "start",
                  width: "12%",
                  cursor: "pointer"
                },
                cellStyle: {
                  textAlign: "start",
                  padding: "7px 0px 7px 13px",
                  width: "12%",
                },
                render: (rowData) => rowData?.finance_approver_amount ? rowData?.finance_approver_amount : "-"
              },
              {
                field: "approver_comment",
                title: "Comment",
                sorting: false,
                headerStyle: {
                  textAlign: "center",
                  width: "5%",
                  cursor: "default"
                },
                cellStyle: {
                  textAlign: "center",
                  width: "5%"
                },
                render: (rowData) => {
                  return (
                    <Box width={"90%"} onClick={(e) => e.stopPropagation()}>
                       <Tooltip title={rowData?.approver_comment || ""} arrow>
                          <CommentIcon sx={{
                            fontSize: "20px",
                            color: rowData?.approver_comment ? "#637381" : "#95a0ab", 
                            cursor: rowData?.approver_comment ? "pointer" : "default", 
                          }}  />
                       </Tooltip> 
                    </Box>
                  );
                },
              },
              {
                title: "Actions",
                field: "actions",
                headerStyle: {
                  textAlign: "center",
                  width: "10%",
                  cursor: "default"
                },
                cellStyle: {
                  textAlign: "center",
                  width: "10%"
                },
                sorting: false,
                render: (rowData) => (
                  <>
                    <Tooltip
                      title={
                        rowData.employee_status === "Rejected"
                          ? "Edit"
                          : ""
                      }
                    >
                      <span>
                        <IconButton
                          sx={{ padding: "0px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(rowData);
                          }}
                          disabled={rowData.employee_status !== "Rejected"}
                        >
                          <EditIcon />
                        </IconButton>
                      </span>
                    </Tooltip>

                    <Tooltip
                      title={
                        rowData.employee_status === "Rejected"
                          ? "Delete"
                          : ""
                      }
                    >
                      <span>
                        <IconButton
                          sx={{ padding: "0px", ml: "8px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleConfirmDelete(rowData);
                          }}
                          disabled={rowData.employee_status !== "Rejected"}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </>
                ),
              },
            ]}
            data={employee_expenses || []}
            options={{
              maxBodyHeight: "calc(100vh - 185px)",
              minBodyHeight: "calc(100vh - 185px)",
              rowStyle: {
                fontSize: "13px",
                height: "45px",
              },
              headerStyle: {
                padding: "7px 10px 7px 10px",
                fontWeight: "bold",
              },
              cellStyle: {
              padding: "5px 0px 5px 13px"
              },
              sorting: true,
              search: true,
              searchFieldAlignment: "right",
              searchAutoFocus: false,
              filtering: false,
              paging: true,
              pageSizeOptions: [25, 50],
              pageSize: 25,
              selection: false,
              actionsColumnIndex: -1,
              grouping: false,
              columnsButton: false,
              showTitle: true,
              exportAllData: false,
              exportButton: false,
            }}
            title="Expense Claims"
          />
        </Box>
        <Popup
          title={editedRecord ? "Edit Expense" : "Add Expense"}
          openPopup={openPopup}
          setOpenPopup={closeMode}
          fullWidth={true}
          maxWidth="xs"
        >
          <AddExpensePopUp
            setOpenPopup={setOpenPopup}
            editedRecord={editedRecord}
            closeMode={closeMode}
          />
        </Popup>
        <ConfirmationDialog
          title="Do you wish to proceed?"
          openDialog={openDialog}
          closeDialog={setOpenDialog}
          popupTitle="Country Management"
          OkButtonText="Delete"
          onSubmit={handleDelete}
        />
      </Box>
    </Base>
  );
};

const getStatusColor = (status) => {
  switch (status) {
    case "Pending Approval":
      return { bg: "#FFF4E5", text: "#FFA726" }; // yellow
    case "Approved":
      return { bg: "#E8F5E9", text: "#66BB6A" }; // green
    case "Rejected":
      return { bg: "#FFEBEE", text: "#EF5350" }; // red
    case "Submitted":
      return { bg: "#E3F2FD", text: "#42A5F5" };
    default:
      return { bg: "#E5E7EB", text: "#374151" }; // gray
  }
};

export default MyExpense;
